import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '.././i18n'

import axios from 'axios'

import Release from '../views/Release.vue'
import News from '../views/News.vue'
import Ministries from '../views/Ministries.vue'
import Search from '../views/Search.vue'
import Media from '../views/Media.vue'
import Contacts from '../views/Contacts.vue'
import Timeline from '../views/Timeline.vue'
import Stream from '../views/Stream.vue'

import PageNotFound from '../views/PageNotFound.vue'

Vue.use(VueRouter)

/* Route Matching Priority */
// If a url matches multiple routes it will match the first one it finds based on the order below

const routes = [
  // redirects to release
  {
    path: '/m/:release_id',
    name: 'oldShortlinkRelease',
  },
  /* *** SEARCH *** */
  {
    path: '/search/:lang(en|fr)',
    name: 'search',
    component: Search,
    props: true,
    meta: {
      title: {
        en: 'Search',
        fr: 'Recherche'
      }
    }
  },
  /* *** STREAMS *** */
  // {
  //   path: '/timeline/:lang(en|fr)',
  //   name: 'timeline',
  //   component: Timeline,
  //   props: true,
  //   meta: {
  //     title: {
  //       en: 'All Streams',
  //       fr: 'Tous les canaux'
  //     }
  //   }
  // },
  // {
  //   path: '/timeline/:stream_id/:lang(en|fr)',
  //   name: 'stream',
  //   component: Stream,
  //   props: true
  // },
  /* *** MEDIA *** */
  {
    path: '/media/:lang(en|fr)',
    name: 'media',
    component: Media,
    props: true,
    meta: {
      title: {
        en: 'Media',
        fr: 'Médias'
      }
    }
  },
  {
    path: '/contacts/:lang(en|fr)',
    name: 'contacts',
    component: Contacts,
    props: true,
    meta: {
      title: {
        en: 'Media Contacts',
        fr: 'Renseignements'
      }
    }
  },
  /* *** HOME *** */
  {
    path: '/',
    alias: ['/profiles', '/profiles/*'],
    redirect: '/en',
    name: 'root',
    component: News
  },
  {
    path: '/:lang(en|fr)',
    alias: ['/newsroom/:lang', '/archive/:lang', '/newsroom/:lang/index.html'],
    name: 'home',
    component: News,
    props: true,
    meta: {
      title: {
        en: 'Recent News',
        fr: 'Nouvelles récentes'
      }
    }
  },
  /* *** ALL BULLETINS *** */
  {
    path: '/bulletins/:lang(en|fr)',
    alias: ['/archive/bulletins/:lang(en|fr)', '/newsroom/:lang/bulletins', '/newsroom/archive/:lang/bulletins'],
    name: 'bulletins',
    component: News,
    props: { hasPagination: true, page: 1, limit: 15 },
    meta: {
      title: {
        en: 'Bulletins',
        fr: 'Bulletins'
      },
      type: 2005
    }
  },
  /* *** ALL MEDIA ADVISORIES *** */
  {
    path: '/advisories/:lang(en|fr)',
    archive: '/archive/media/:lang',
    name: 'advisories',
    component: News,
    props: { hasPagination: true, page: 1, limit: 15 },
    meta: {
      title: {
        en: 'Advisories',
        fr: 'Avis aux médias'
      },
      type: 2002
    }
  },
  /* *** ALL NEWS RELEASES *** */
  {
    path: '/releases/:lang(en|fr)',
    name: 'releases',
    component: News,
    props: { hasPagination: true, page: 1, limit: 15 },
    meta: {
      title: {
        en: 'Releases',
        fr: 'Communiqués'
      },
      type: 2001
    }
  },
  /* *** ALL NEWS TYPES *** */
  {
    path: '/news/:lang(en|fr)',
    name: 'news',
    component: News,
    props: { hasPagination: true, page: 1, limit: 15 },
    meta: {
      title: {
        en: 'All News',
        fr: 'Toutes les nouvelles'
      }
    }
  },
  /* *** ALL MINISTRIES *** */
  {
    path: '/ministries/:lang(en|fr)',
    alias: ['/:lang/ministries', '/newsroom/:lang/ministries'],
    name: 'ministries',
    component: Ministries,
    props: true,
    meta: {
      title: {
        en: 'Ministries',
        fr: 'Ministères'
      }
    }
  },
  // Can likely pass a ministry id to the news component to filter it
  {
    path: '/:acronym/:lang(en|fr)',
    name: 'ministry',
    component: News,
    props: { hasPagination: true, page: 1, limit: 15 }
  },
  /* *** SPECIFIC NEWS RELEASE *** */
  // redirects to release
  {
    path: '/m/:lang(en|fr)/:release_id',
    name: 'shortlinkRelease',
  },

  {
    path: '/:lang(en|fr)/:type/:release_id/:slug',
    name: 'release',
    component: Release,
    props: true
  },
  {
    path: '/:acronym/:lang(en|fr)/:year/:month/:slug',
    name: 'legacyRelease',
  },
  {
    path: '/archive/:lang(en|fr)/:year/:month/:day/:permalink',
    name: 'archiveRelease',
  },
  {
    path: '/preview/:lang(en|fr)/:id/:key',
    name: 'previewRelease',
    component: Release,
    props: true,
  },
  {
    path: '*',
    name: 'errorPage',
    component: PageNotFound,
    props: { code: 404, message: 'Page not found' }
  }
  /* *** EXAMPLE ROUTE *** */
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  // this allows in-page anchor links to work as expected in all borwsers (previously they wroked incorrectly in firefox)
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes
})

// There seems to be a bug with history mode regarding case insensitivity (the bug is logged in router version 2.8.1 but still seems to be present)
// https://github.com/vuejs/vue-router/issues/2154
// I've stripped down the suggested patch function
if (router.mode === 'history') {
  router.history.getCurrentLocation = function () {
    let path = window.location.pathname
    // Lowercase the path and then append any query strings
    path = path.toLowerCase() + window.location.search

    return path
  }
}

router.beforeEach((to, from, next) => {
  // If there is a language apramater in the url, set the site language to match it
  if (to.params.lang) {
    i18n.locale = to.params.lang
  }

  // Set the base site title in English Or French
  let siteTitle = (i18n.locale == 'en') ? 'Ontario Newsroom' : 'Salle de presse de l’Ontario'

  // If a route with a title was found, set the document (page) title to that value.
  if (to.meta.title) {
    document.title = to.meta.title[i18n.locale] + ' | ' + siteTitle
  } else {
    document.title = siteTitle
  }

  /* If the incoming route is a legacy or archive release, do a lookup and route to the new release route
   * e.g. '/:lang(en|fr)/:type/:release_id/:slug'
   * otherwise route to error page
   */ 
  if (['legacyRelease', 'archiveRelease'].includes(to.name)) {
    let url = to.path.split('.')
    let slug = url[0].replace('/','');

    const http = axios.create({
      baseURL: process.env.VUE_APP_ROOT_API,
    })

    http
      .get('legacy', {
        params: {
          slug: slug,
        }
      })
      .then(response => {
        let release = response.data
        router.push({ name: 'release',
                      params: { lang: release.language,
                                type: release.type,
                                release_id: release.id,
                                slug: release.slug,
                                hideLanguageToggle: true
                              },
                    })
      })
      .catch(error => {
        router.push({ name: 'errorPage' })
      })
  }

  /* Route to regular release route if shortlink is entered */
  if (['oldShortlinkRelease', 'shortlinkRelease'].includes(to.name)) {
    router.push({ name: 'release',
                  params: { lang: to.params.lang ? to.params.lang : 'en',
                            type: 'type',
                            release_id: to.params.release_id,
                            slug: 'shortlink-redirect',
                          },
                })
    
  }

  next()
})




var excludedRoutes = ['shortlinkRelease', 'release', 'legacyRelease', 'archiveRelease', 'ministry']

router.afterEach((to) => {
  if (!excludedRoutes.includes(to.name)) {
    setTimeout(function () {
      window.dataLayer.push({
        'event': 'Pageview',
        'pagePath': window.location.href,
        'pageTitle': document.title,
        'ministryOwner': undefined
      })
    }, 1000)
  }
})

export default router
